import { isValid } from "date-fns";

export function isValidDate(date: string): boolean {
  return isValid(new Date(date));
}
